import BaseService from "../../../base/base_service";
import {SYSTEM_EVENTS} from "../../../events/events";
import FallbackHandlerDependenciesFactory from "./fallback_handlers_dependencies_factory";

export default class FallbackService extends BaseService {

    static CLASS = 'FallbackService';

    /**
     * @property
     * @type {Object}
     * @private
     */
    _handlersContext = require.context('./handlers/', true, /^.*(handler)\.[jt]s$/);


    _fallbackHandlers = [];


    _initParams;


    init(params) {
        super.init(params);
        this._initParams = params;
        this._dependenciesFactory = params.dependenciesFactory;
        this.subscribe();
    }


    subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, this._onInitComplete);
    }

    _onInitComplete() {
        if (!this._dependenciesFactory) {
            let dependencies = Object.assign({}, {serviceFactory: this.serviceFactory}, this._initParams);
            this._dependenciesFactory = FallbackHandlerDependenciesFactory.create(dependencies);
        }

        this._handlersContext.keys().map(this._handlersContext).forEach((handler) => {
            this._fallbackHandlers.push(this._dependenciesFactory.createHandler(handler.default.FallbackName));
        })
    }


    /**
     * Find Fallback by name
     * @param handlerName
     * @returns {*}
     * @private
     */
    _getFallbackByName(handlerName) {
        return this._fallbackHandlers.find((handler) => {
            return handler.getFallbackName() === handlerName
        });
    }

    /**
     * Start all fallbacks. If fallbackName parameter passed, start only specified fallback
     * Specified fallback is used for partial fallback only (for example only for Wallet)
     * @param fallbackName
     */
    start(fallbackName) {
        if (!fallbackName) {
            this.logger.debug('Start fallback process for all messages!');
            this._fallbackHandlers.forEach((fallback) => {
                this._startFallback(fallback)
            });
            return;
        }

        let fallback = this._getFallbackByName(fallbackName);
        if (fallback) {
            this._startFallback(fallback);
        }
    }


    /**
     * Stop all fallbacks. If fallbackName parameter passed, stop only specified fallback
     * Specified fallback is used for partial fallback only (for example only for Wallet)
     * @param handlerName
     */
    stop(fallbackName) {
        if (!fallbackName) {
            this.logger.debug('Stop fallback process for all messages!');
            this._fallbackHandlers.forEach((fallback) => {
               this._stopFallback(fallback);
            });
        }

        let fallback = this._getFallbackByName(fallbackName);
        if (fallback) {
           this._stopFallback(fallback);
        }
    }

    _stopFallback(fallback) {
        this.logger.debug(`Stop fallback process for ${fallback.getFallbackName()} messages!`);
        fallback.stop();
    }

    _startFallback(fallback) {
        this.logger.debug(`Start fallback process for ${fallback.getFallbackName()} messages!`);
        fallback.start();
    }


    stopAllFallbacks() {
        this._fallbackHandlers.forEach((fallback) => {
            this._stopFallback(fallback);
        });
    }
}